import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PatchPlan = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the standalone PatchPlan HTML file
    // This avoids the iframe complexity and focus issues
    window.location.href = '/patchplan/index.html';
  }, []);

  // Return null since we're redirecting
  return null;
};

export default PatchPlan;

